export default {
  __name__: '简体中文',
  // Main page
  registration_deadline_: '注册截止时间',
  qualification_: 'qualification_',
  online_jeopardy: 'Online Jeopardy',
  final_: '最后',
  prizes_: '奖项',
  event_organizer_: '赛事组织者',
  about_: '关于',
  news_: '公告板',
  challenge_: '赛题',
  rank_main_title_: 'Rank',
  trend_main_title_: 'Trend',
  news_main_title_: '',
  rank_table_: '排行榜',
  trend_: '趋势图',
  scoreboard_: '记分板',
  countdown_: '距离比赛开始',
  myTeam_: '我的队伍',
  login_: '登入',
  profile_: '个人资料',
  changePwd_: '更改密码',
  logout_: '登出',
  // About page
  competitionInfo_: '比赛信息',
  competitionTime_: '比赛时间',
  contact_: '联系方式',
  prize_: '奖项设置',
  categories_: '题目种类',
  rules_: '比赛规则',
  organizer_: '组织方',
  sponsors_: '赞助商',
  media_: '媒体',
  // Profile page
  location_: '地区',
  email_: '邮箱',
  solvedChallenges_: '已解决题目',
  name_: '名称',
  score_: '分数',
  time_: '时间',
  rank_: '排名',
  solved_: '已解决',
  total_: '总计',
  inputToken_: '输入token来加入队伍',
  join_: '加入',
  or_: '或',
  createTeam_: '点击这里来创建队伍',
  team_: '队伍',
  player_: '选手',
  userId_: '用户ID',
  // Challenge info page
  teamSolved_: '您的团队已经解决了这个题目',
  ctfOver_: '本场CTF已经结束',
  teamSolvedCount_: '已被 {{totalSolved}} 个团队解决',
  userSolvedCount_: '已被 {{totalSolved}} 个选手解决',
  solvedSuccessfully_: '解题成功',
  errParam_: 'Flag 无效',
  errNoLogin_: '请先登入',
  errGameOver_: '已超过提交时间',
  errWrongFLag_: 'Flag 错误',
  // Challenge page
  challenges_: '赛题',
  topTeams_: '龙虎榜',
  // Create team page
  createYourTeam_: '创建您的团队',
  teamName_: '团队名称',
  submit_: '提交',
  reset_: '重置',
  changeLogo_: '稍后您可以在团队页面上传团队LOGO',
  // Change password page
  password_: '密码',
  newPwd_: '新密码',
  retypePwd_: '再次输入新密码',
  notMatch_: '两次输入的密码不符！',
  // Login page
  username_: '用户名',
  register_: '注册',
  forgetPwd_: '忘记密码？',
  // Register page
  registerUser_: '用户注册（非团队）',
  clickToLogin_: '点击此处登入',
  invalidUsername_: '用户名不合法！',
  invalidEmail_: 'E-mail不合法！',
  fillAll_: '请填写全部输入框！',
  // News page
  postedOn_: '发表于',
  // Team page
  teamMembers_: '团队成员',
  teamToken_: '团队 Token',
  clickToUpload_: '点击LOGO图片以上传团队LOGO',
  solvedBy_: '解出者',
  hacker_: 'Hacker',
  // Trend page
  finishedTime_: '选手末次解题时间',
  trendBoard_: '趋势图',
  // Countdown page
  timeLeft_: '距离比赛结束',
  gameOver_: '比赛已结束',
  days_: '天'
}



// WEBPACK FOOTER //
// ./src/i18n/zh-cn.js